import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, MenuItem } from '@material-ui/core';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import {
  Card,
  CardBody,
  CardHeader
} from '../../../_metronic/_partials/controls';
import { TextField } from '../../components/common/TextField';
import { ActionBarAdd as ActionBar } from '../../components/common/ActionBar';
import { fetchAnimalCategoryList } from '../../../redux/animalCategory/list';
import { addAnimalType } from '../../../redux/animalType/ops';

const AnimalAddPage = () => {
  // Prereq Hooks
  const dispatch = useDispatch();

  // Animal Category
  const { data: animalCategoryList } = useSelector(
    state => state.animalCategory.list
  );
  useEffect(() => {
    dispatch(fetchAnimalCategoryList());
  }, []);

  const { completed } = useSelector(state => state.animalType.ops);
  const isFetching = useSelector(state => state.loading.animalType);
  useEffect(() => {
    if (completed) {
      resetForm();
    }
  }, [completed]);

  const {
    values,
    errors,
    touched,
    handleChange,
    handleSubmit,
    handleReset,
    setFieldValue,
    setFieldError,
    resetForm
  } = useFormik({
    initialValues: {
      category: '',
      name: ''
    },
    validationSchema: Yup.object({
      category: Yup.string().required('Cannot be empty'),
      name: Yup.string().required('Cannot be empty')
    }),
    onSubmit: values => {
      dispatch(addAnimalType(values));
    }
  });

  return (
    <Card>
      <CardHeader title="Animal type details"></CardHeader>
      <CardBody>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="category"
                select
                value={values.category}
                onChange={event => {
                  setFieldValue('category', event.target.value);
                }}
                label="Category *"
                helperText={touched.category ? errors.category : ''}
                error={touched.category && errors.category ? true : false}
              >
                {animalCategoryList.map(({ id, category_name }) => (
                  <MenuItem value={id}>{category_name}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="name"
                value={values.name}
                onChange={handleChange}
                label="Animal Type *"
                helperText={touched.name ? errors.name : ''}
                error={touched.name && errors.name ? true : false}
              />
            </Grid>
            <ActionBar
              isFetching={isFetching}
              handleSubmit={handleSubmit}
              handleReset={handleReset}
            />
          </Grid>
        </form>
      </CardBody>
    </Card>
  );
};

export default AnimalAddPage;
